export const LOGOUT_GET_REQUESTING = 'LOGOUT_GET_REQUESTING';
export const LOGOUT_GET_SUCCESS = 'LOGOUT_GET_SUCCESS';
export const LOGOUT_GET_ERROR = 'LOGOUT_GET_ERROR';